import type { DataImport } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function setToUnprocessed(id: string): Promise<Partial<DataImport.RawVehicle>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/vehicle/set-to-unprocessed?id=${id}`, {
      method: 'PATCH',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
